module.exports = __webpack_public_path__ + "img/dashboard-mandatory-questionnaire.e044e2de.png";